// Brief full-screen loader shown when Agentic Mode is toggled ON.
// Lives inside the .agent-console token scope so all colors and motion match
// the rest of the Workspace — every keyframe lives in agent-console.css.
import { cn } from '@/lib/utils'
import { SparkIcon } from '../console/icons'
import '../styles/agent-console.css'

const TITLE_WORDS = ['Preparing', 'your', 'workspace']

function AgenticModeLoader() {
    return (
        <div
            className={cn(
                'agent-console fixed inset-0 z-[60]',
                'flex items-center justify-center',
            )}
            style={{ background: 'var(--bg)' }}
            role='status'
            aria-live='polite'
            aria-label='Preparing Agentic Mode'
        >
            <div className='agentic-loader-stack flex flex-col items-center'>
                <span
                    className='agentic-loader-mark inline-flex h-10 w-10 items-center justify-center rounded-full'
                    style={{
                        background: 'var(--surface)',
                        boxShadow: 'var(--shadow-soft)',
                        border: '1px solid var(--line)',
                        color: 'var(--ink)',
                    }}
                    aria-hidden='true'
                >
                    <SparkIcon size={18} />
                </span>

                <span className='mt-5 text-[10.5px] font-semibold uppercase tracking-[0.18em] text-[var(--ink-faint)]'>
                    Agentic Mode
                </span>

                <h2 className='mt-2.5 flex flex-wrap justify-center text-[17px] font-semibold tracking-tight text-[var(--ink)]'>
                    {TITLE_WORDS.map((word, i) => (
                        <span
                            key={`${word}-${i}`}
                            className='agentic-loader-word inline-block'
                            style={{ animationDelay: `${140 + i * 70}ms` }}
                        >
                            {word}
                            {i < TITLE_WORDS.length - 1 ? '\u00A0' : ''}
                        </span>
                    ))}
                </h2>

                <p className='agent-shimmer mt-1.5 text-[12.5px] font-medium tracking-tight'>
                    Loading your context
                </p>

                <div
                    className='relative mt-6 h-[2px] w-[200px] overflow-hidden rounded-full'
                    style={{ background: 'var(--surface-strong)' }}
                >
                    <div
                        className='agentic-loader-fill h-full rounded-full'
                        style={{ background: 'var(--ink)' }}
                    />
                </div>

                <div
                    className='agent-dots mt-3 inline-flex items-end gap-[4px] text-[var(--ink-faint)]'
                    aria-hidden='true'
                >
                    <span className='agent-dot' />
                    <span className='agent-dot' />
                    <span className='agent-dot' />
                </div>
            </div>
        </div>
    )
}

export default AgenticModeLoader
